import { redirect } from "react-router";
import { signOut } from "~/auth.server";
import { $LOADER, $PAGE } from "~/util/Loaders";
import { logPageView } from "~/util/stats";

$PAGE({
  path: "logout",
  loader: $LOADER?.(async (cx) => {
    // Log
    logPageView(cx);
    //
    const sess = cx.req.sess;
    if (sess) {
      await signOut(cx.res, sess.session.id);
    }
    return redirect("/");
  }),
  meta: (cx) => {
    return { title: `Logout - L2Hub.info`, canonicalUrl: `/logout` };
  },
  render: () => {
    return (
      <div
        className="content"
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          paddingTop: 20,
        }}
      >
        Logging out of the system...
      </div>
    );
  },
});
